import { formatCurrency, formatDate } from '@/common/utils/formatters'
import { EstablishmentPointData, EstablishmentPointTableItem } from '@/features/tmaisUsers/types/tmaisUserPoints.type'

const PointCell = ({ value }: { value: string }) => (
  <div className="flex items-center gap-1.5">
    <img src="/TCoinPoint.svg" alt="TCoinPoint" className="size-5" />
    <span>{Number(value ?? 0)}</span>
  </div>
)

export class EstablishmentPointsTransformer {
  static tableTransformer() {
    return (points: EstablishmentPointData[]): EstablishmentPointTableItem[] => {
      return points.map((point) => ({
        establishment: point.general_information?.fantasy_name,
        total_amount_consumed: formatCurrency(Number(point.total_amount_consumed ?? 0)),
        available_points_total: <PointCell value={point.available_points_total} />,
        earned_points_total: <PointCell value={point.earned_points_total} />,
        most_recent_reward_ledger_created_at: point.most_recent_reward_ledger_created_at
          ? formatDate(new Date(point.most_recent_reward_ledger_created_at))
          : '',
      }))
    }
  }
}
